/**
 * Simple test component to verify icon system works
 * This will be removed once we confirm everything works
 */

import { createIconButton } from "./IconButton/index";
import { getIconNames } from "./Icon/index";

export const createIconTest = (container: HTMLElement) => {
  const testContainer = document.createElement("div");
  testContainer.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: white;
    border: 2px solid #ddd;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    z-index: 1000;
    max-width: 500px;
    max-height: 80vh;
    overflow: hidden;
    display: none;
  `;

  const title = document.createElement("h3");
  title.textContent = "Icon System Test";
  title.style.margin = "0 0 16px 0";
  testContainer.appendChild(title);

  const iconGrid = document.createElement("div");
  iconGrid.style.cssText = `
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 16px;
    margin-bottom: 16px;
    max-height: 400px;
    overflow-y: auto;
  `;

  // Get ALL loaded icons dynamically
  const allIconNames = getIconNames();
  console.log(`Testing ${allIconNames.length} icons`);

  allIconNames.forEach((iconName) => {
    try {
      const iconButton = createIconButton({
        icon: iconName,
        size: 32,
        title: iconName,
        className: "icon-button--sm",
        onClick: () => {
          console.log(`Clicked: ${iconName}`);
          iconButton.setSelected(
            !iconButton.getElement().classList.contains("icon-button--selected")
          );
        },
      });

      iconGrid.appendChild(iconButton.getElement());
    } catch (error) {
      console.warn(`Failed to create button for ${iconName}:`, error);

      // Create fallback button
      const fallback = document.createElement("div");
      fallback.textContent = iconName;
      fallback.style.cssText = `
        padding: 8px;
        border: 1px solid red;
        border-radius: 4px;
        font-size: 10px;
        text-align: center;
        color: red;
      `;
      iconGrid.appendChild(fallback);
    }
  });

  testContainer.appendChild(iconGrid);

  // Status info
  const status = document.createElement("div");
  status.style.cssText = "font-size: 12px; color: #666;";
  status.textContent = `Icons loaded: ${getIconNames().length}`;
  testContainer.appendChild(status);

  // Close button
  const closeBtn = document.createElement("button");
  closeBtn.textContent = "×";
  closeBtn.style.cssText = `
    position: absolute;
    top: 8px;
    right: 8px;
    border: none;
    background: none;
    font-size: 18px;
    cursor: pointer;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  `;
  closeBtn.onclick = () => testContainer.remove();
  testContainer.appendChild(closeBtn);

  container.appendChild(testContainer);

  return {
    toggle: () => {
      const isVisible = testContainer.style.display !== "none";
      testContainer.style.display = isVisible ? "none" : "block";
    },
    destroy: () => testContainer.remove(),
  };
};
